import script from "./Choice.vue?vue&type=script&lang=ts&setup=true"
export * from "./Choice.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__